import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmDialogComponent } from '../../../../components/confirm-dialog/confirm-dialog.component';
import { PositionService } from '../../../../core/api/position.service';
import { HelpersService } from '../../../../core/services/helpers.service';
import { LoadingService } from '../../../../core/services/loading.service';

@Component({
  selector: 'app-action-position',
  standalone: true,
  imports: [CommonModule, MatSelectModule, FormsModule, ReactiveFormsModule],
  templateUrl: './action-position.component.html',
  styleUrl: './action-position.component.scss',
})
export class ActionPositionComponent {
  m: any;
  id: any;
  form: FormGroup;

  constructor(
    private activatedRoute: ActivatedRoute,
    private helpers: HelpersService,
    private fb: FormBuilder,
    private router: Router,
    private positionService: PositionService,
    private dialog: MatDialog,
    private loadingService: LoadingService,
  ) {
    this.m = this.activatedRoute.snapshot.queryParams['m'];
    this.id = this.activatedRoute.snapshot.queryParams['id'];
    this.form = this.fb.group({
      name: [null, [Validators.required]],
      code: [null, [Validators.required]],
      reportScope: ['none', [Validators.required]],
      description: [null],
    });
  }

  ngOnInit(): void {
    this.getDataById().catch(() => {
      this.helpers.sbError('Terjadi kesalahan saat memuat data.');
    });
  }

  getDataById(): Promise<void> {
    return new Promise((resolve, reject) => {
      if (this.id) {
        this.loadingService.startLoading();
        this.positionService.getById(this.id).then(
          (data) => {
            this.loadingService.endLoading();
            this.form.patchValue(data);
            resolve();
          },
          (error) => {
            this.loadingService.endLoading();
            this.helpers.sbError(error.message);
            reject(error);
          },
        );
      } else {
        resolve();
      }
    });
  }

  submit(): void {
    if (this.form.valid) {
      this.dialog
        .open(ConfirmDialogComponent, {
          width: '545px',
          maxHeight: '95vh',
          panelClass: 'confirm-dialog',
          data: {
            title: `Confirm ${
              this.m == 'add' ? 'Add New Position' : 'Edit Position'
            }`,
            message:
              'Changes to the position cannot be undone once saved. Are you sure you want to proceed?',
          },
        })
        .afterClosed()
        .subscribe((result: any) => {
          if (result) {
            this.loadingService.startLoading();
            const actionPromise =
              this.m == 'add'
                ? this.positionService.insert(this.form.value)
                : this.positionService.updateById(this.id, this.form.value);

            actionPromise
              .then(() => {
                this.loadingService.endLoading();
                this.helpers.sbSuccess(
                  `Position berhasil ${
                    this.m == 'add' ? 'ditambahkan' : 'diperbarui'
                  }!`,
                );
                this.router.navigate(['/dashboard/position']);
              })
              .catch((error) => {
                this.loadingService.endLoading();
                this.helpers.sbError(error.message);
              });
          }
        });
    } else {
      this.helpers.sbError('Lengkapi form terlebih dahulu!');
    }
  }

  cancel() {
    this.router.navigate(['/dashboard/position']);
  }
}
